<template>
  <div class="text">
    <v-container class="pa-0">
      <v-layout row wrap ref="content" style="padding-bottom: 0">
        <v-flex xs12>
          <v-card flat class="pa-3 v-cls-header" v-if="headerImage || headerVideo">
          <v-img v-if="headerImage" :src="headerImage"></v-img>
            <div v-html="headerVideo" v-if="headerVideo"></div>
          </v-card>
          <v-card  class="pa-0" flat color="#EDEFF0">
            <v-card-text>
              <div v-html="content"></div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-footer ref="footer" fixed color="white" height="auto">
      <v-container class="pa-0" fluid style="padding-top: 0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn v-if="buttons[text_id].bigButton" block color="accent" class="v-btn--block--footer" dark @click="$router.push(buttons[text_id].bigButton.route)">{{ buttons[text_id].bigButton.label }} <i class="icon icon-kruidvat-arrow icon-white"></i></v-btn>
            <div class="v-btn--footer--direct_photo"><a href="/photo">Ken je de instructies? Ga direct een foto maken.</a></div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
  import BackendService from '@/services/BackendService'

  export default {
    data: () => {
      return {
        title: '',
        headerVideo: '',
        headerImage: '',
        content: '',
        videoHeight: 0,
        buttons: {
          1: { // home
            bigButton: {label: 'Hoe werkt het?', route: '/hoe-werkt-het'},
            kvButton: {label: 'Pasfoto maken', route: '/photo'},
          },
          7: { // hoe-werkt-het
            bigButton: {label: 'Extra instructies nodig?', route: '/instructies'},
            kvButton: {label: 'Pasfoto maken', route: '/photo'},
          },
          2: { // tips
            bigButton: {label: 'Extra instructies nodig?', route: '/instructies'},
            kvButton: {label: 'Pasfoto maken', route: '/photo'},
          },
          3: { // veelgestelde-vragen
            bigButton: {label: 'Extra instructies nodig?', route: '/instructies'},
            kvButton: {label: 'Pasfoto maken', route: '/photo'},
          },
          4: { // veelgestelde-vragen
            bigButton: {label: 'Extra instructies nodig?', route: '/instructies'},
            kvButton: {label: 'Pasfoto maken', route: '/photo'},
          },
          5: { // veelgestelde-vragen
            bigButton: {label: 'Extra instructies nodig?', route: '/instructies'},
            kvButton: {label: 'Pasfoto maken', route: '/photo'},
          },
          6: { // veelgestelde-vragen
            bigButton: {label: 'Extra instructies nodig?', route: '/instructies'},
            kvButton: {label: 'Pasfoto maken', route: '/photo'},
          }
        }
      }
    },
    props: {
      text_id: Number,
    },

    created() {
      this.fetchData()
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize',this.resizeVideo);
        window.addEventListener('resize',this.addFooterPadding);
      });
    },
    updated() {
      this.addFooterPadding();
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchData'
    },
    methods: {
      fetchData() {
        BackendService.getText(this.text_id)
          .then((response) => {
            this.headerVideo = '';
            this.headerImage = '';
            this.title = response.data.title;
            this.content = response.data.content;
            if (response.data['video']) {
              let url = response.data['video'];
              let embedUrl = this.getVimeoUrl(url);
              if (embedUrl === false) {
                embedUrl = this.getYoutubeUrl(url)
              }

              if (embedUrl !== false) {
                this.headerVideo = "<iframe id='video' style='width:100%;height:100%' src=\"" + embedUrl + "\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>"
              }
              this.$nextTick(() => {
                this.resizeVideo();
              });
            } else if (response.data['image']) {
              this.headerImage = response.data['image'];
            }

          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getVimeoUrl(url) {
        let regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
        let match = url.match(regExp);
        if (match){
          console.log('Found vimeo id ' + match[2]);
          return 'https://player.vimeo.com/video/' + match[2];
        } else {
          console.log('No vimeo id in ' + url);
          return false;
        }
      },
      getYoutubeUrl(url) {
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        let match = url.match(regExp);

        if (match && match[2].length == 11) {
          return 'https://www.youtube.com/embed/' + match[2];
        } else {
          return false;
        }
      },
      resizeVideo() {
        let video = document.getElementById('video');
        if (video !== null) {
          let videoWidth = video.offsetWidth;
          let h = videoWidth / 16 * 9;
          video.style.height = h + 'px';
        }
      },
      addFooterPadding() {
        let content = this.$refs.content;
        let footer = this.$refs.footer;
        if (content && footer) {
          let footerHeight = footer.$el.offsetHeight;
          if (content.offsetHeight > window.innerHeight - 80 - footerHeight) {
            this.$refs.content.style.paddingBottom = (footerHeight + 20) + 'px';
          }
        }
      }
    }
  }
</script>

<style scoped>
  .video-wrapper {
    padding: 10px;
    margin: 15px 0;
  }

</style>